import axios from 'axios';
import { call, put, takeLatest, all } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import {
  API_BASE_URL,
  getRequest,
  postRequest,
  putRequest,
  deleteRequest,
  extractErrorMessage,
} from '../../../api';
import {
  GET_ALL_REPORT_CONFIGURATIONS_REQUEST,
  getAllReportConfigurationsRequest,
  getAllReportConfigurationsSuccess,
  getAllReportConfigurationsFail,
  CREATE_REPORT_CONFIGURATION_REQUEST,
  createReportConfigurationSuccess,
  createReportConfigurationFail,
  UPDATE_REPORT_CONFIGURATION_REQUEST,
  updateReportConfigurationSuccess,
  updateReportConfigurationFail,
  DELETE_REPORT_CONFIGURATION_REQUEST,
  deleteReportConfigurationSuccess,
  deleteReportConfigurationFail,
  GET_KPI_REPORTS_REQUEST,
  getKpiReportsSuccess,
  getKpiReportsFail,
  EXPORT_REPORT_REQUEST,
  exportReportSuccess,
  exportReportFail,
} from '../actions/reportActions';

const safeArray = (value) => (Array.isArray(value) ? value : []);
const getToken = () => sessionStorage.getItem('token');
const getUid = () => sessionStorage.getItem('uid');
const getTenantId = () => sessionStorage.getItem('selectedCompanyId');

function* getAllReportConfigurationsSaga() {
  const url = `${API_BASE_URL}/api/reporting/configurations`;
  try {
    const resp = yield call(getRequest, { url, token: getToken() });
    yield put(getAllReportConfigurationsSuccess(safeArray(resp.data)));
  } catch (error) {
    yield put(getAllReportConfigurationsFail(extractErrorMessage(error, error.message)));
  }
}

function* createReportConfigurationSaga(action) {
  const url = `${API_BASE_URL}/api/reporting/configurations`;
  console.group('CREATE_KPI_REPORT');
  console.log('payload', action.payload);
  console.log('url', url);
  try {
    const resp = yield call(postRequest, { url, data: action.payload, token: getToken() });
    console.log('response', resp);
    yield put(createReportConfigurationSuccess(resp?.data || null));
    yield put(getAllReportConfigurationsRequest());
    yield call([Swal, Swal.fire], { icon: 'success', text: 'Etat Excel enregistre avec succes', timer: 1800, showConfirmButton: false });
  } catch (error) {
    const message = extractErrorMessage(error, error.message);
    console.log('error', error);
    yield put(createReportConfigurationFail(message));
    yield call([Swal, Swal.fire], { icon: 'error', text: message });
  } finally {
    console.groupEnd();
  }
}

function* updateReportConfigurationSaga(action) {
  const { id, data } = action.payload;
  const url = `${API_BASE_URL}/api/reporting/configurations/${id}`;
  try {
    const resp = yield call(putRequest, { url, data, token: getToken() });
    yield put(updateReportConfigurationSuccess(resp.data));
    yield put(getAllReportConfigurationsRequest());
    yield call([Swal, Swal.fire], { icon: 'success', text: 'Etat Excel mis a jour', timer: 1800, showConfirmButton: false });
  } catch (error) {
    const message = extractErrorMessage(error, error.message);
    yield put(updateReportConfigurationFail(message));
    yield call([Swal, Swal.fire], { icon: 'error', text: message });
  }
}

function* deleteReportConfigurationSaga(action) {
  const url = `${API_BASE_URL}/api/reporting/configurations/${action.payload.id}`;
  try {
    yield call(deleteRequest, { url, token: getToken() });
    yield put(deleteReportConfigurationSuccess(action.payload.id));
    yield put(getAllReportConfigurationsRequest());
  } catch (error) {
    yield put(deleteReportConfigurationFail(extractErrorMessage(error, error.message)));
  }
}

function* getKpiReportsSaga(action) {
  const { dashboardKey, runtimeFilters } = action.payload;
  const url = `${API_BASE_URL}/api/reporting/dashboard/${dashboardKey}`;
  console.group('GET_DASHBOARD_REPORTS');
  console.log('params', action.payload);
  console.log('url', url);
  try {
    const resp = yield call(postRequest, { url, data: runtimeFilters || {}, token: getToken() });
    console.log('response', resp);
    yield put(getKpiReportsSuccess(safeArray(resp.data)));
  } catch (error) {
    console.log('error', error);
    yield put(getKpiReportsFail(extractErrorMessage(error, error.message)));
  } finally {
    console.groupEnd();
  }
}

function* exportReportSaga(action) {
  const { reportId, runtimeFilters } = action.payload;
  const url = `${API_BASE_URL}/api/reporting/export/${reportId}`;
  try {
    const resp = yield call([axios, axios.post], url, runtimeFilters || {}, {
      responseType: 'blob',
      headers: {
        uid: getUid(),
        Authorization: `Bearer ${getToken()}`,
        'X-Tenant-Id': getTenantId(),
        Accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'Content-Type': 'application/json',
      },
    });

    const blob = new Blob([resp.data], { type: resp.headers['content-type'] || 'application/octet-stream' });
    const objectUrl = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = objectUrl;
    link.download = `report-${reportId}.xlsx`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(objectUrl);

    yield put(exportReportSuccess(reportId));
  } catch (error) {
    const message = extractErrorMessage(error, error.message);
    yield put(exportReportFail(message));
    yield call([Swal, Swal.fire], { icon: 'error', text: message });
  }
}

export default function* reportSagas() {
  yield all([
    takeLatest(GET_ALL_REPORT_CONFIGURATIONS_REQUEST, getAllReportConfigurationsSaga),
    takeLatest(CREATE_REPORT_CONFIGURATION_REQUEST, createReportConfigurationSaga),
    takeLatest(UPDATE_REPORT_CONFIGURATION_REQUEST, updateReportConfigurationSaga),
    takeLatest(DELETE_REPORT_CONFIGURATION_REQUEST, deleteReportConfigurationSaga),
    takeLatest(GET_KPI_REPORTS_REQUEST, getKpiReportsSaga),
    takeLatest(EXPORT_REPORT_REQUEST, exportReportSaga),
  ]);
}
